<script setup>
  
  import { onBeforeUnmount, ref, watch } from 'vue';
  import { placeholdAction } from '../editor/actions/placeholderAction';
  import Button from '../components/Button.vue';
import { animatedPlaceholder } from './animatedPlaceholder';


  const {send: sendUp, abort, ready, streaming, immediatePrompt, enableAnimatedPlaceholder} = defineProps({
    send: Function,
    abort: Function,
    ready: Boolean,
    streaming: Boolean,
    placeholder: String,
    enableAnimatedPlaceholder: Boolean
  })

  const prompt = ref('')

  function send(event) {

    if (event.shiftKey || !ready || streaming) {
      return;
    }

    sendUp(prompt.value)
    prompt.value = ''
  }

  const generatedPlaceholder = ref(null)
  let stopGeneratingPlaceholder = null;

  watch(() => enableAnimatedPlaceholder, (val) => {
    console.log("watching:", val)
    if (val) {
      stopGeneratingPlaceholder = animatedPlaceholder(p => generatedPlaceholder.value = p)      
    } else {
      stopGeneratingPlaceholder?.()
      generatedPlaceholder.value = null
    }
    console.log("watching:", val)

  }, {immediate: true});


  onBeforeUnmount(() => {
    if (stopGeneratingPlaceholder) {
      stopGeneratingPlaceholder()
    }
  })

</script>

<template>  
  <div class="prompt border-1 border-base-content/20">
    <div class="pb-1 flex justify-end">
      <slot />
    </div>
    <textarea v-model="prompt" @keyup.enter="send" :placeholder="generatedPlaceholder ?? placeholder ??  'Ask AI here...'" />
    <div class="buttons">
      <Button title="attach files to the message" class="btn btn-ghost btn-circle" @action="placeholdAction"><v-icon name="fa-paperclip" /></Button>
      <div class="a-flex-1"></div>
      <slot name="controls-right"/>      
      <Button class="btn btn-ghost btn-circle" title="stop responding" v-if="streaming" @action="abort"><v-icon size="10" name="fa-square" /></Button>
      <Button class="btn btn-ghost btn-circle" v-else :disabled="!ready || !prompt || /^\s*$/.test(prompt)" @action="send"><v-icon name="fa-arrow-up" /></Button>          
    </div>
  </div>

</template>
<style scoped lang='less'>
.prompt {

  background: var(--color-base-100);
  
  // border-color: var(--color-base-300);
  border-radius: 5px;
  padding: 10px;
  padding-bottom: 3px;
  display: flex;
  flex-direction: column;

  textarea:focus,
  textarea:focus-visible {
    outline: none;
  }

  textarea {
    background: var(--color-base-100);

    padding-right: 10px;
    flex-grow: 1;

    border: none;
    resize: none;
    height: 100px;
  }

  .buttons {

    button {
      svg {
        width: 25px;
        height: 25px;
      }
    }

    display: flex;
  }

}

</style>